export function formatPrice(currency: string, price: number) {
  return Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
    currencyDisplay: 'code',
  })
    .format(price)
    .replace(currency, '');
}
